module.exports = __webpack_public_path__ + "static/media/makeorder.21b19b08.png";